import { Checkbox, MenuItem } from '@mui/material';
import { Stack } from '@mui/system';
import { TimePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { useState } from 'react';
import { TableInput } from '../../../../../components/common';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import formatDate from '../../../../../components/common/formatDate';
import { TableCompHead } from '../../../../../components/ui';
import { useQuery } from '../../../../../hooks/UseQuery';
import { convToTime } from '../../../../../utils/helpers';
import CustomSelect from '../../../../../components/common/SelectField';

interface IProps {
  moduleData: any;
  isView: boolean;
  operation: string[];
  getProcess: any;
}
const tableHead: any = {
  setup: ['FM-QAD-35', '07', '13.03.2020'],
  retro: ['FM-QAD-35A', '00', '01.01.2019'],
  suspected: ['', '00', '01-04-2023'],
};

const heading: any = {
  setup: 'First Off Approval',
  retro: 'Part Inspection Report',
  suspected: 'SUSPECTED CHECK RECORDS',
};
const THead = ({ getProcess, moduleData, isView, operation }: IProps) => {
  const [render, setRender] = useState(false);
  const documentType = useQuery('documentType') || '';
  const machine_no = useQuery('machine_no') || '';
  const operation_name = useQuery('operation_name') || '';
  const process_name = useQuery('process_name') || '';
  const process_no = useQuery('process_no') || '';
  return (
    <thead>
      <TableCompHead
        colSpan={18}
        rowSpan={3}
        labels={['Doc No', 'Rev', 'Eff. Date']}
        values={tableHead[documentType]}
        heading={heading[documentType]}
      />
      <tr>
        <th align="left" colSpan={4}>
          Process Name : {process_name}
        </th>
        <th align="left" colSpan={5}>
          Process No : {process_no}
        </th>
        <th align="left" colSpan={5}>
          Terminal/Name/No :
          <TableInput
            isView={isView}
            name="terminal_name"
            type="text"
            value={moduleData?.terminal_name}
            onChange={(e) => {
              moduleData.terminal_name = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
        <th align="left" colSpan={4}></th>
      </tr>
      <tr>
        <th align="left" colSpan={4}>
          Wire Harness Number :
          <TableInput
            isView={isView}
            name="wire_harness_no"
            type="text"
            value={moduleData?.wire_harness_no}
            onChange={(e) => {
              moduleData.wire_harness_no = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
        <th align="left" colSpan={5}></th>
        <th align="left" colSpan={5}>
          Applicator No. :
          <TableInput
            isView={isView}
            name="application_no"
            type="text"
            value={moduleData?.application_no}
            onChange={(e) => {
              moduleData.application_no = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
        <th align="left" colSpan={4}></th>
      </tr>
      <tr>
        <th align="left" colSpan={4}>
          Prod Start Date & Time :
          {isView ? (
            formatDate(moduleData.start_date)
          ) : (
            <DatePickerMui
              label=""
              value={
                moduleData.start_date ? moment(moduleData.start_date) : null
              }
              onChange={(date: any) => {
                moduleData.start_date = date;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
        <th align="left" colSpan={5}>
          PROD END DATE / TIME :
          {isView ? (
            formatDate(moduleData.end_date)
          ) : (
            <DatePickerMui
              label=""
              value={moduleData.end_date ? moment(moduleData.end_date) : null}
              onChange={(date: any) => {
                moduleData.end_date = date;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
        <th align="left" colSpan={5}></th>
        <th align="left" colSpan={4}></th>
      </tr>
      <tr>
        <th align="left" colSpan={4}>
          M/C NO. : {machine_no}
        </th>
        {documentType === 'setup' && (
          <>
            <th align="center" colSpan={5}>
              <div>
                (FIRST OFF APPROVAL)
                <br />
                (1). Display Set Up pieces at machine till the end of set up
                <br />
                (2). Mark pieces rejected during set up as set up reject & keep
                in red bin
              </div>
            </th>
            <th align="center" colSpan={9}>
              <div>
                (LAST OFF APPROVAL)
                <br />
                (1). verify last three pieces for Crimp Height & Crimp Width And
                appearance
                <br />
                (2). Mix up the first off & Last off Pieces with production lot
                after completeion of batch
              </div>
            </th>
          </>
        )}
        {documentType === 'retro' && (
          <th align="center" colSpan={14}>
            <div>Retro inspection</div>
          </th>
        )}
      </tr>
      {/* <tr>
        <th align="left" colSpan={4}>
          Customer Name:
          {moduleData?.customer_name ||
            moduleData.part_id?.customer_id?.customer_name}
        </th>
        <th align="left" colSpan={7}>
          Machine Name:{machineName}
        </th>
        <th colSpan={7} align="left">
          <Stack style={{ gap: '5px' }}>
            Date:-
            {isView ? (
              formatDate(moduleData.date)
            ) : (
              <DatePickerMui
                value={moment(moduleData.date || null)}
                onChange={(date) => {
                  moduleData.date = date;
                  setRender((prev) => !prev);
                }}
              />
            )}
          </Stack>
        </th>
      </tr> */}
      {/* <tr>
        <th colSpan={4} align="left">
          Operation Name & No. :
          {isView ? (
            moduleData.operation_name
          ) : (
            <CustomSelect
              name="operation_name"
              value={moduleData.operation_name || operation_name || ''}
              onChange={(e) => {
                getProcess(e.target.value);
                setRender((prev) => !prev);
              }}
            >
              <MenuItem value="">None</MenuItem>
              {operation.map((name) => (
                <MenuItem value={name}>{name}</MenuItem>
              ))}
            </CustomSelect>
          )}
        </th>
        <th colSpan={7}></th>
        <th colSpan={7} align="left">
          Sample Size :
          <TableInput
            isView={isView}
            name="sample_size"
            type="text"
            value={moduleData?.sample_size}
            onChange={(e) => {
              moduleData.sample_size = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
      </tr> */}
      {/* <tr>
        <th colSpan={4} align="left">
          PART NAME: {moduleData.part_name || moduleData.part_id?.part_name}
        </th>
        <th colSpan={7} align="left">
          PART NO: {moduleData?.part_number || moduleData.part_id?.part_number}
        </th>

        <th colSpan={7} align="left"></th>
      </tr> */}
      <tr>
        <th rowSpan={2}>S.NO.</th>
        {/* <th colSpan={2}>DESCRIPTION</th> */}
        <th rowSpan={2}>INSPECTION PARAMETER</th>
        <th rowSpan={2}>SPECIFICATION</th>
        <th rowSpan={2}>METHOD OF CHECKING</th>
        <th colSpan={10}>OBSERVATIONS</th>
        <th rowSpan={2}>RESULT</th>
        {/* <th rowSpan={2}>APPROVAL BY</th> */}
        <th rowSpan={2}>REMARKS</th>
        <th rowSpan={2} colSpan={2}>
          ACTION
        </th>
      </tr>
      <tr>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((head: any, index) => (
          <th
            key={head + index + 'heading'}
            style={{ textTransform: 'uppercase' }}
          >
            {head}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
